import { useEffect, useCallback } from 'react'
import { useAuth } from '../contexts/AuthContext'

const useTheme = () => {
  const { user, updateProfile } = useAuth()
  const theme = user?.preferences?.theme || 'light'

  const applyTheme = useCallback((themeValue) => {
    const root = document.documentElement

    if (themeValue === 'dark') {
      root.classList.add('dark')
    } else if (themeValue === 'auto') {
      const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches
      root.classList.toggle('dark', prefersDark)
    } else {
      root.classList.remove('dark')
    }
  }, [])

  useEffect(() => {
    applyTheme(theme)

    if (theme === 'auto') {
      const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')
      const handler = (e) => {
        document.documentElement.classList.toggle('dark', e.matches)
      }
      mediaQuery.addEventListener('change', handler)
      return () => mediaQuery.removeEventListener('change', handler)
    }
  }, [theme, applyTheme])

  const isDark = theme === 'dark' || (theme === 'auto' && window.matchMedia('(prefers-color-scheme: dark)').matches)

  const setTheme = useCallback(async (newTheme) => {
    applyTheme(newTheme)
    await updateProfile(
      { preferences: { ...user?.preferences, theme: newTheme } },
      { silent: true },
    )
  }, [applyTheme, updateProfile, user?.preferences])

  return { theme, isDark, setTheme }
}

export default useTheme
